module.exports = __webpack_public_path__ + "bb0cfc5319528c6a6366627037e95e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/content/highwaymow.jpg
// module id = 118
// module chunks = 1